<template>
    <!-- Footer -->
    <footer class="footer footer-five">

        <!-- Footer Top -->
        <div class="footer-top aos" data-aos="fade-up">
            <div class="container">
                <div class="row">
                    <div class="col-lg-4 col-md-6">
                        <!-- Footer Widget -->
                        <div class="footer-widget">
                            
                            <div class="footer-content">
                                <h2 class="footer-subtitle">Newsletter Signup</h2>
                            <div class="subscribe-form">
                                <input type="email" class="form-control" placeholder="Enter Email Address">
                                <div class="footer-btn">
                                    <button type="submit" class="btn btn-dark">
                                        Send
                                    </button>
                                </div>
                                
                            </div>
                        </div>
                                <!-- Footer Widget -->
                        <div class="footer-widget">
                            <h2 class="footer-title">Connect With us</h2>
                            <div class="social-icon">
                                <ul>
                                    <li>
                                        <a href="javascript:void(0);"><i class="ti ti-brand-facebook"></i> </a>
                                    </li>
                                    <li>
                                        <a href="javascript:void(0);"><i class="ti ti-brand-twitter"></i> </a>
                                    </li>
                                    <li>
                                        <a href="javascript:void(0);"><i class="ti ti-brand-youtube"></i></a>
                                    </li>
                                    <li>
                                        <a href="javascript:void(0);"><i class="ti ti-brand-linkedin"></i></a>
                                    </li>
                                </ul>
                            </div>
                            <div class="download-icons">
                                <a href="#"><img src="@/assets/img/appstore-five.svg" alt="img" class="img-fluid"></a>
                                <a href="#"><img src="@/assets/img/googleplay-five.svg" alt="img" class="img-fluid"></a>
                            </div>
                        </div>
                        <!-- /Footer Widget -->
                        </div>
                        <!-- /Footer Widget -->
                    </div>
                    <div class="col-lg-2 col-md-6">
                        <!-- Footer Widget -->
                        <div class="footer-widget footer-menu">
                            <h2 class="footer-title fs-18">Support</h2>
                            <ul>
                                <li>
                                    <a href="#" class="fs-16">Account</a>
                                </li>
                                <li>
                                    <a href="#" class="fs-16">Book Appointment</a>
                                </li>
                                <li>
                                    <a href="#" class="fs-16">Orders</a>
                                </li>
                                <li>
                                    <a href="#" class="fs-16">Payments</a>
                                </li>
                                <li>
                                    <a href="#" class="fs-16">Returns</a>
                                </li>
                                <li>
                                    <a href="#" class="fs-16">Contact Us</a>
                                </li>
                            </ul>
                        </div>
                        <!-- /Footer Widget -->
                    </div>
                    <div class="col-lg-2 col-md-6">
                        <!-- Footer Widget -->
                        <div class="footer-widget footer-menu">
                            <h2 class="footer-title fs-18">About</h2>
                            <ul>
                                <li>
                                    <a href="#" class="fs-16">Categories</a>
                                </li>
                                <li>
                                    <a href="#" class="fs-16">Services</a>
                                </li>
                                <li>
                                    <a href="#" class="fs-16">About us</a>
                                </li>
                                <li>
                                    <a href="#" class="fs-16">FAQ</a>
                                </li>
                                <li>
                                    <a href="#" class="fs-16">Blog</a>
                                </li>
                                <li>
                                    <a href="#" class="fs-16">Terms</a>
                                </li>
                            </ul>
                        </div>
                        <!-- /Footer Widget -->
                    </div>
                    <div class="col-lg-3 col-md-6">
                        <!-- Footer Widget -->
                        <div class="footer-widget footer-contact">
                            <h2 class="footer-title">Contact Us</h2>
                            <div class="footer-contact-info">
                                <div class="d-flex align-items-center">
                                    <div class="icons">
                                        <span class="rounded-circle"><i class="ti ti-phone"></i></span>
                                    </div>
                                    <div>
                                        <p class="fs-14 text-white  mb-1">Phone Number</p>
                                        <p class="fs-14 text-white mb-0">310-437-2766</p>
                                    </div>
                                </div>
                            </div>
                            <div class="footer-contact-info">
                                <div class="d-flex align-items-center">
                                    <div class="icons">
                                        <span class="rounded-circle"><i class="ti ti-mail"></i></span>
                                    </div>
                                    <div>
                                        <p class="fs-14 text-white  mb-1">Mail Address</p>
                                        <p class="fs-14 text-white mb-0">contact@truelysell.com</p>
                                    </div>
                                </div>
                            </div>
                            <div class="footer-contact-info">
                                <div class="d-flex align-items-center">
                                    <div class="icons">
                                        <span class="rounded-circle"><i class="ti ti-map-pin"></i></span>
                                    </div>
                                    <div>
                                        <p class="fs-14 text-white  mb-1">Address</p>
                                        <p class="fs-14 text-white mb-0">706 Campfire Ave. Meriden, CT </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- /Footer Widget -->
                    </div>
                    
                </div>
            </div>
        </div>
        <!-- /Footer Top -->

        <!-- Footer Bottom -->
        <div class="footer-bottom-car">
            <div class="container">
                <!-- Copyright -->
                <div class="copyright">
                    <div class="row align-items-center gy-3 justify-content-lg-center">
                        <div class="col-md-6 col-lg-4">
                            <div class="copyright-text">
                                <p class="mb-0">Copyright © 2025. All Rights Reserved.</p>
                            </div>
                        </div>
                        <div class="col-md-6 col-lg-4">
                            <div class="payment-image">
                                <ul>
                                    <li>
                                        <a href="javascript:void(0);"><img src="@/assets/img/payment/visa.png"
                                                alt="img"></a>
                                    </li>
                                    <li>
                                        <a href="javascript:void(0);"><img src="@/assets/img/payment/mastercard.png"
                                                alt="img"></a>
                                    </li>
                                    <li>
                                        <a href="javascript:void(0);"><img src="@/assets/img/payment/stripe.png"
                                                alt="img"></a>
                                    </li>
                                    <li>
                                        <a href="javascript:void(0);"><img src="@/assets/img/payment/discover.png"
                                                alt="img"></a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        
                        <div class="col-md-6 col-lg-4">
                            <!-- Copyright Menu -->
                            <div class="copyright-menu">
                                <ul class="policy-menu">
                                    <li>
                                        <router-link to="/pages/privacy-policy">Privacy Policy</router-link>
                                    </li>
                                    <li>
                                        <router-link to="/pages/terms-condition">Terms & Conditions</router-link>
                                    </li>
                                </ul>
                            </div>
                            <!-- /Copyright Menu -->
                        </div>
                    </div>
                </div>
                <!-- /Copyright -->
            </div>
        </div>
        <!-- /Footer Bottom -->

    </footer>
    <!-- /Footer -->
</template>

<script>
export default {
    data() {
        return {
            
        }
    },
}
</script>